import { Grid, Typography, Box, Card, CardContent, CardMedia } from "@mui/material";
import _ from "lodash";

const ProductList = ({ productList, order, formatCurrency, currencySymbol }) => {
  return (
    <Grid item container spacing={2} xs={12} sm={12} md={12} lg={12} >
      {productList.map((product, i) => (
        <Grid item xs={12} sm={12} md={12} lg={12} key={i} >
          <Card sx={{ display: "flex",height:"12rem"}}>
            <Grid xs={5} lg={5}>

              {_.get(product, "product_detail.images[0].image") ? (
                <CardMedia
                  component="img"
                  image={_.get(product, "product_detail.images[0].image", "")}
                  alt={_.get(product, "product_detail.product_name", "")}
                  sx={{ height:'100%', width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" }, objectFit: { xs: "contain", sm: "contain", md: "contain", lg: "contain" } }}
                />
              ) : (
                <Box sx={{
                  height: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
                  width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  border: "1px dashed rgba(0, 0, 0, 0.2)"
                }}>
                  <Typography variant="body2" color="textSecondary">
                    No Image
                  </Typography>
                </Box>
              )}
            </Grid>
            <Grid xs={8} lg={8}>

              <CardContent sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Box>

                <Typography variant="h6" noWrap>
                  {_.get(product, "product_detail.product_name") ?
                    _.truncate(_.get(product, "product_detail.product_name"), { length: 25 }) :
                    `Product ID: ${product.product_id || 'N/A'}`
                  }
                </Typography>
                  </Box>
                <Box >
                  <Typography variant="body2">Qty: {product.quantity}</Typography>
                  {console.log("product details", product)}
                  {(product?.product_detail?.size?.name &&
                    product?.product_detail?.size?.name !== '' &&
                    product?.product_detail?.size?.name !== 'null') && <Typography variant="body2">Size: {product?.product_detail?.size?.name}</Typography>
                  }
                  {(product?.product_detail?.color?.name &&
                    product?.product_detail?.color?.name !== '' &&
                    product?.product_detail?.color?.name !== 'null') && <Typography variant="body2">Color: {product?.product_detail?.color?.name}</Typography>
                  }
                  <Typography variant="body2" color="textSecondary">
                    {product.delivery_status_type}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {order.selected_payment_mode.Name}
                  </Typography>
                </Box>
                <Box>

                <Typography variant="h6" mb={2}>
                  <b>{currencySymbol} {(_.get(product, "total_price", 0))}</b>
                </Typography>
                </Box>
              </CardContent>
            </Grid>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductList;
